import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { fetchMedia, fetchSocialPostsThunk } from 'slices/influencer/thunk';
import { AppDispatch, RootState } from 'store';
import MediaGrid from './MediaGrid';
import { Post } from 'types/influencer';
import SocialMediaGrid from './SocialMediaGrid';
import { SocialPost } from 'types/campaign/collaborations';

interface InfluencerYTVideosProps {
    socialAccountId: string,
    onMediaClick: (post: SocialPost) => void
}


const InfluencerYTVideos: React.FC<InfluencerYTVideosProps> = ({ socialAccountId, onMediaClick }) => {

    const dispatch: AppDispatch = useDispatch();

    const videosData = useSelector((state: RootState) => state.influencers.social_media[socialAccountId]?.VIDEO);

    const videos = videosData?.items ?? [];
    const page = videosData?.page ?? 1;
    const has_more = videosData?.has_more ?? true;

    const loading = useSelector((state: RootState) => state.influencers.mediaLoading);


    useEffect(() => {
        if (socialAccountId)
            dispatch(fetchSocialPostsThunk({ page: 1, socialAccountId, type: 'VIDEO' }));
    }, [socialAccountId])

    const nextPage = () => {
        if (has_more && socialAccountId) {
            const nextPageNumber = page + 1;
            dispatch(fetchSocialPostsThunk({ page: nextPageNumber, socialAccountId, type: 'VIDEO' }))
        }
    }

    return (
        <SocialMediaGrid onGridItemClick={onMediaClick} media={videos} onNextPage={nextPage} has_more={has_more} contentLoading={loading} />
    )
}

export default InfluencerYTVideos